import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import Image from "../../components/Image";
// hooks
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

export default function FeeTaxDialog({ isOpen, close }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="dg">
      <DialogContent sx={{ p: { xs: 3, sm: 4 }, pb: "0!important" }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          수수료, 세금 정책
        </Typography>
        {smUp ? (
          <Image
            disabledEffect
            visibleByDefault
            alt="fee-tax-guide"
            src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/img_crewfee.png"
            srcSet="
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/img_crewfee.png 1x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/img_crewfee-2x.png 2x,
            "
          />
        ) : (
          <Image
            disabledEffect
            visibleByDefault
            alt="fee-tax-guide-mo"
            src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/img_crewfee_mo.png"
            srcSet="
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/img_crewfee_mo.png 1x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/img_crewfee_mo-2x.png 2x,
            "
          />
        )}
        <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
          계약한 인건비에서 수수료와 소득세를 차감한 금액이 지급됩니다.
        </Typography>
        <ul style={{ marginLeft: "16px", marginBottom: "8px" }}>
          <li>
            <Typography variant="body2" gutterBottom>
              수수료 : 계약 체결 시 인건비의 10%, 해당 계약의 재계약 부터는 인건비의 3%입니다.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              소득세 : 인건비에서 수수료를 제외한 금액의 3.3%입니다.
            </Typography>
          </li>
        </ul>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button
          onClick={close}
          variant="contained"
          size="large"
          sx={{ px: 5 }}
          fullWidth={!smUp}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}